export class AccountGroup {
  public id?: string;
  public name: string;
}
